import React from 'react'
import "./styles.css"
import iconIRGTLogoWhite from '../../../images/logo-CS-horizontal-morado.png'

interface Props {
    title: string;
    subTitle: string;
    listViewInitial: Array<string>;
    descriptionParrafoOne: string;
    descriptionParrafoTwo: string;
    descriptionParrafoThree: string;
}
// Component
const InitialView: React.FC<Props> = ({ title, subTitle, listViewInitial, descriptionParrafoOne, descriptionParrafoThree, descriptionParrafoTwo }) => {
    return (
        <div className='container'>
            <img
                alt="icon Irgt"
                src={iconIRGTLogoWhite}
                className='imgCareerSwipe'

            />
            <div style={{ height: '60vh', width: '100%' }}>
                <h1 className='title-initial-view'>{title}</h1>

                <p className='subtitle-initial-view'>
                    {subTitle}
                </p>
                <ul className='normal-text-bold-initial-view'>
                    {
                        listViewInitial.map((item: string) => (
                            <li key={item}>{item}</li>
                        ))
                    }

                </ul>
                <p className='normal-text-initial-view'>
                    {descriptionParrafoOne}
                </p>
                <p className='normal-text-initial-view'>
                    {descriptionParrafoTwo}
                </p>
                <p className='normal-text-initial-view'>
                    {descriptionParrafoThree}
                </p>

            </div>
        </div>
    )
}

// Export
export default InitialView
